// src/lib/posthog/client-log.ts
//
// The one logger the PostHog modules and the error boundaries use.
// It prints an error's name, its HTTP status and a stable code — never a
// message and never a response body, so a third-party failure can never leak
// customer data into the console (and from there into a recording).
//
// `ClientErrorInfo` deliberately has no `message` or `body` field: a caller
// cannot pass one by accident.

export interface ClientErrorInfo {
  /** The error's class name (`error.name`), never `error.message`. */
  name: string;
  /** HTTP status, when the failure came from a response. */
  status?: number;
  /** A stable, non-user-facing code chosen by the caller. */
  code?: string;
}

export function logClientError(scope: string, info: ClientErrorInfo): void {
  const parts = [`[posthog] ${scope}: ${info.name}`];
  if (info.status !== undefined) parts.push(`status=${info.status}`);
  if (info.code !== undefined) parts.push(`code=${info.code}`);
  console.error(parts.join(" "));
}
